import * as React from "react";
import { PropsWithChildren } from "react";
import { styled } from "styled-components";

import { anchorKey } from "../index";

const SectionEl = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h3`
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${(props) => props.theme.colours.bordersDark};
  margin-bottom: 1rem;
`;

export const Section: React.FC<PropsWithChildren<{ title?: Maybe<string>; anchor?: Maybe<string> }>> = ({
  title,
  children,
  anchor,
}) => {
  const anchorId = anchor ?? (title ? anchorKey(title) : null);
  return (
    <SectionEl data-doc="section" {...{ id: anchorId ? `${anchorId}-section` : undefined }}>
      {title && (
        <SectionTitle data-doc="title" {...{ id: anchorId ?? undefined }}>
          {title}
        </SectionTitle>
      )}
      {children}
    </SectionEl>
  );
};
